import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Icon } from '../Icon';
import * as React from 'react';
import { IVehicleSearch } from '../../interfaces/VehicleSearch';
import styles from "./VehicleSearch.module.scss";
import { translateService, Translate } from '../../services/TranslateService';
import { useSelector } from 'react-redux';
import { GlobalStore } from '../../reduxStore';
import {useContext} from "react";
import {DataContext} from "../../contexts/dataContext";
interface PropsInterface {
    vehicle: IVehicleSearch;
    detailsVisible:boolean;
    setDetailsVisible:React.MouseEventHandler<HTMLDivElement>;
    children?: React.ReactNode;
  }
export default function VehicleDetails({ vehicle, detailsVisible, setDetailsVisible, children}: PropsInterface) {
    const language = useSelector((state: GlobalStore) => state.chauffeurReducer.deviceLanguage);
    const dataContext = useContext(DataContext);
    let fuelType: string;
    if (+vehicle.vehicleData.fuelType === 0)
        fuelType = translateService.translate('vehicleSearch.diesel');
    else if (+vehicle.vehicleData.fuelType === 1)
        fuelType = translateService.translate('vehicleSearch.95E');
    else
        fuelType = translateService.translate('vehicleSearch.electric');

    if (vehicle.vehicleData.hybridity === 'normal')
        fuelType += " - "+ translateService.translate('vehicleSearch.hybrid');
    else if (vehicle.vehicleData.hybridity !== 'none')
        fuelType += " - "+ translateService.translate('vehicleSearch.plugin');

    return <>
            <div className={styles.moreButtonRatingContainer}>
                <div className={styles.moreButtonToggle} onClick={setDetailsVisible}>
                <strong>
                    <Translate content={detailsVisible ? 'vehicleSearch.close' : 'vehicleSearch.moreDetails'} />
                    &nbsp;
                    <Icon icon={detailsVisible ? faChevronUp : faChevronDown} />
                </strong>
                </div>
                <div className='w-100 d-flex justify-content-end'>
                    {children}
                </div>
            </div>
        {detailsVisible && <>
            <div className={styles.description}>{language === 'fi' ? vehicle.vehicleModelData.descr : vehicle.vehicleModelData.descren}
                {vehicle.vehicleModelData.presentationUrl! && vehicle.vehicleModelData.presentationUrl !== '' ?
                    <> <br/>
                        <a href={vehicle.vehicleModelData.presentationUrl}>{vehicle.vehicleModelData.presentationUrl}</a>
                    </> : null}
            </div>

            <div className={styles.detailsInfoSection}>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon}
                         src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-mileage.svg'}
                         alt="icon-car-feature-mileage" loading="lazy"/>
                    <span>
                        <Translate component='strong' content='welcomePhase.vehicleInfoModal.mileage' />
                        {vehicle.vehicleData.currentMileage} km
                    </span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon} src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-license.svg'} alt="icon-car-feature-license" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.license' />
                        {vehicle.vehicleData.drivingLisenceType === 1 ? 'B' : 'B'} </span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon}
                         src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-engine.svg'}
                         alt="icon-car-feature-engine" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.engine' />{vehicle.vehicleData.engineDisplacement} L</span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon} src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-fuel-type.svg'} alt="icon-car-feature-fuel-type" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.fuelType' />
                        {fuelType}
                    </span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon} src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-power.svg'} alt="icon-car-feature-power" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.power' />
                        {vehicle.vehicleData.enginePower} kW</span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon} src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-consumption.svg'} alt="icon-car-feature-consumption" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.consumption' />
                        {vehicle.vehicleData.combinedConsumption} L/100 km</span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon} src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-width.svg'} alt="icon-car-feature-width" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.width' />
                        {vehicle.vehicleModelData.dimensions.vehicleWidth} cm</span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon} src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-height.svg'} alt="icon-car-feature-height" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.height' />
                        {vehicle.vehicleModelData.dimensions.vehicleHeight} cm</span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon} src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-length.svg'} alt="icon-car-feature-length" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.length' />
                        {vehicle.vehicleModelData.dimensions.vehicleLength} cm</span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon} src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-mass.svg'} alt="icon-car-feature-mass" loading="lazy"/>
                    <span><Translate component='strong' content='welcomePhase.vehicleInfoModal.mass' /> {vehicle.vehicleData.totalMass} kg </span>
                </div>
                { vehicle.vehicleData.loadCapacity !== 0 ? (
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon}
                         src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-max-payload.svg'}
                         alt="icon-car-feature-max-payload" loading="lazy"/>
                    <span>
                    <Translate component='strong' content='welcomePhase.vehicleInfoModal.payload' /> {vehicle.vehicleData.loadCapacity} kg
                    </span>
                </div>
                ) : null}

                {vehicle.vehicleModelData.dimensions.trunkHeight !== 0 ? (
                        <div className={styles.detailItem}>
                                <img width="45" height="33" className={styles.carDetailIcon}
                                     src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-cargo-height.svg'}
                                     alt="icon-car-feature-cargo-height" loading="lazy"/>
                                <span>
                                    <Translate component='strong' content='welcomePhase.vehicleInfoModal.cargoHeight' /> {vehicle.vehicleModelData.dimensions.trunkHeight} cm
                                </span>
                        </div>
                    ) : null }

                {vehicle.vehicleModelData.dimensions.trunkWidth !== 0 ? (
                            <div className={styles.detailItem}>
                                <img width="45" height="33" className={styles.carDetailIcon}
                                     src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-cargo-width.svg'}
                                     alt="icon-car-feature-cargo-width" loading="lazy"/>
                                <span>
                                    <Translate component='strong' content='welcomePhase.vehicleInfoModal.cargoWidth' />
                                    {vehicle.vehicleModelData.dimensions.trunkWidth} cm
                                </span>

                            </div>
                    ) : null }

                {
                    vehicle.vehicleModelData.dimensions.trunkDepth !== 0 ? (
                        <div className={styles.detailItem}>
                            <img width="45" height="33" className={styles.carDetailIcon}
                                 src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-cargo-length.svg'}
                                 alt="icon-car-feature-cargo-length" loading="lazy"/>
                            <span>
                                <Translate component='strong' content='welcomePhase.vehicleInfoModal.cargoLength' />
                                {vehicle.vehicleModelData.dimensions.trunkDepth} cm
                            </span>

                        </div>
                    ) : null }

                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon}
                         src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-aircon.svg'}
                         alt="icon-car-feature-aircon" loading="lazy"/>
                    <span>
                        <Translate component='strong' content='welcomePhase.vehicleInfoModal.airCon' />
                        { vehicle.vehicleData.hasAirConditioning ? (
                            <Translate content='welcomePhase.vehicleInfoModal.yes' />) :
                        (<Translate content='welcomePhase.vehicleInfoModal.no' />)}
                    </span>

                </div>

                {vehicle.vehicleModelData.type === 'car' ? (
                    <div className={styles.detailItem}>
                        <img width="45" height="33" className={styles.carDetailIcon}
                             src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-isofix.svg'}
                             alt="icon-car-feature-isofix" loading="lazy"/>
                        <span>
                            <Translate component='strong' content='welcomePhase.vehicleInfoModal.isofix' /> <Translate content='welcomePhase.vehicleInfoModal.yes' /></span>
                    </div>
                ) : null}
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon}
                         src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-abs.svg'}
                         alt="icon-car-feature-abs" loading="lazy"/>
                    <span>
                        <Translate component='strong' content='welcomePhase.vehicleInfoModal.abs' />{vehicle.vehicleData.hasAbs ? (
                        <Translate content='welcomePhase.vehicleInfoModal.yes' />) : (<Translate content='welcomePhase.vehicleInfoModal.no' />)}
                    </span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon}
                         src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-heater.svg'}
                         alt="icon-car-feature-heater" loading="lazy"/>
                    <span>
                        <Translate component='strong' content='vehicleSearch.heater' /> {vehicle.vehicleData.hasHeater ? (
                            <Translate content='welcomePhase.vehicleInfoModal.yes' />) : (<Translate content='welcomePhase.vehicleInfoModal.no' />)}
                    </span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon}
                         src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-cruise-control.svg'}
                         alt="icon-car-feature-cruise-control" loading="lazy"/>
                    <span>
                        <Translate component='strong' content='welcomePhase.vehicleInfoModal.cruise' />{vehicle.vehicleData.hasCruiseControl ? (
                        <Translate content='welcomePhase.vehicleInfoModal.yes' />) : (<Translate content='welcomePhase.vehicleInfoModal.no' />)}
                    </span>
                </div>
                <div className={styles.detailItem}>
                    <img width="45" height="33" className={styles.carDetailIcon}
                         src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-tires.svg'}
                         alt="icon-car-feature-tires" loading="lazy"/>
                    <span>
                        <Translate component='strong' content='welcomePhase.vehicleInfoModal.tires' /> <Translate content={'welcomePhase.vehicleInfoModal.' + vehicle.vehicleData.tyreType} /></span>
                </div>
                { vehicle.vehicleData.brakedTowingCapacity !== 0 ? (
                        <div className={styles.detailItem}>
                            <img width="45" height="33" className={styles.carDetailIcon}
                                 src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-max-with-brakes.svg'}
                                 alt="icon-car-feature-max-with-brakes" loading="lazy"/>
                            <span>
                                <Translate component='strong' content={'vehicleSearch.maxWithBrakes'} /> {vehicle.vehicleData.brakedTowingCapacity} kg
                            </span>
                        </div>
                    ) : null }
                {vehicle.vehicleData.unbrakedTowingCapacity !== 0 ? (
                        <div className={styles.detailItem}>
                            <img width="45" height="33" className={styles.carDetailIcon}
                                 src={dataContext.rootUrl+'/assets/icons/new/reservation-details/more-details/icon-car-feature-max-without-brakes.svg'}
                                 alt="icon-car-feature-max-without-brakes" loading="lazy"/>
                            <span>
                                <Translate component='strong' content={'vehicleSearch.maxWithoutBrakes'} /> {vehicle.vehicleData.unbrakedTowingCapacity} kg
                            </span>
                        </div>
                    ) : null }
            </div>
            <Translate content={'vehicleSearch.asStatedByImporter'} />
        </>}
      </>
}